import { createContext, PropsWithChildren, useContext, useState } from "react";

interface VerificationState {
  rawInput: string;
  extractedText: string | null;
  sourceUrl: string | null;
  setRawInput: (v: string) => void;
  setExtractedText: (v: string | null) => void;
  setSourceUrl: (v: string | null) => void;
}

const VerificationContext = createContext<VerificationState | null>(null);

export function VerificationProvider({ children }: PropsWithChildren) {
  const [rawInput, setRawInput] = useState("");
  const [extractedText, setExtractedText] = useState<string | null>(null);
  const [sourceUrl, setSourceUrl] = useState<string | null>(null);

  return (
    <VerificationContext.Provider
      value={{
        rawInput,
        extractedText,
        sourceUrl,
        setRawInput,
        setExtractedText,
        setSourceUrl,
      }}
    >
      {children}
    </VerificationContext.Provider>
  );
}

export function useVerification(): VerificationState {
  const ctx = useContext(VerificationContext);
  if (!ctx) throw new Error("useVerification must be used inside VerificationProvider");
  return ctx;
}
